<template>
  <!--@mousemove="handleMouseMove" @mouseleave="resetZoom"-->
  <section>
    <output v-show="isDebug">{{
      JSON.stringify(selectedVolumeLesionTrauma)
    }}</output>

    <svg
      ref="svg"
      width="710"
      height="625"
      viewBox="0 0 710 625"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <rect width="710" height="625" :style="zoomStyle" fill="url(#pattern2)" />
      <g :style="zoomStyle">
        <g id="brainTrauma1">
          <path
            @click="selected('LeftBrain')"
            :class="
              selectedVolumeLesionTrauma.includes('LeftBrain') ? 'selected' : ''
            "
            d="M75,165 
                A 75, 72, 0 ,0 172, 305
                A 75, 73, 0 ,0 176, 165
                Z "
            fill="#a1a25e"
            stroke="black"
          />
        </g>
        <g id="brainTrauma2">
          <path
            @click="selected('LeftMiddleBrain')"
            :class="
              selectedVolumeLesionTrauma.includes('LeftMiddleBrain')
                ? 'selected'
                : ''
            "
            d="M 197,163 
                A 75, 72, 0, 0, 1, 200, 305 
                A 75, 72.5, 0, 0, 1, 200, 163
                Z"
            fill="#a1a25e"
            stroke="black"
          />
        </g>
        <g id="brainTrauma3">
          <path
            @click="selected('RightMiddleBrain')"
            :class="
              selectedVolumeLesionTrauma.includes('RightMiddleBrain')
                ? 'selected'
                : ''
            "
            d="M 340,163 
                A 75, 72, 0, 0, 1, 339, 305 
                A 75, 71.5, 0, 0, 1, 339, 163
                Z"
            fill="#a1a25e"
            stroke="black"
          />
        </g>

        <g id="brainTrauma4">
          <path
            @click="selected('RightBrain')"
            :class="
              selectedVolumeLesionTrauma.includes('RightBrain')
                ? 'selected'
                : ''
            "
            d="M 480,160 
                A 75, 72.6, 0, 0, 1, 480, 305 
                A 75, 74, 0, 0, 1, 480, 160
                Z"
            fill="#a1a25e"
            stroke="black"
          />
        </g>
      </g>
    </svg>
  </section>
</template>

<script setup lang="ts">
import {
  Contexts,
  CurrentCaseServiceInterface,
  getContainer,
  getContext,
  Helpers,
  NamedBindings,
  ApplicationEvents,
  Version,
  CoreConfiguration,
} from '@dandelion/core';
import { onBeforeMount, ref, Ref } from 'vue';
import { isEqual } from 'lodash';

const props = defineProps<{
  context: string;
  fullName: string;
  id: string;
}>();

const coreConfiguration = getContainer(Contexts.DEFAULT).get(
  NamedBindings.CoreConfiguration
) as CoreConfiguration;
const currentCaseService = getContainer(Contexts.DEFAULT).get(
  NamedBindings.CurrentCaseService
) as CurrentCaseServiceInterface;

const isDebug = coreConfiguration.debug;
const selectedVolumeLesionTrauma = ref<Array<string>>([]);
const zoomed = ref(false);
const zoomLevel = ref(2); // Puoi modificare questo valore per cambiare il livello di zoom
const zoomStyle = ref({});

async function selected(selected: string) {
  const model = (await useCurrentContext(props!.context)).model;

  // Imposta il valore selezionato come unico elemento dell'array
  selectedVolumeLesionTrauma.value = [selected];

  // Aggiorna il modello
  Helpers.setObjByPath(props.fullName, model, selectedVolumeLesionTrauma.value);
}

onBeforeMount(async () => {
  const model = (await useCurrentContext(props!.context)).model;

  const selectedVolumeLesionTraumaFromModel = Helpers.getObjByPath(
    props.fullName,
    model
  );
  if (!selectedVolumeLesionTraumaFromModel) {
    return;
  }
  selectedVolumeLesionTrauma.value = selectedVolumeLesionTraumaFromModel ?? [];
});

async function useCurrentContext(context = Contexts.DEFAULT) {
  let crfVersions: Readonly<Ref<ReadonlyMap<string, Version>>> = ref(new Map());
  try {
    crfVersions = ref(currentCaseService.getCrfVersions());
  } catch (e) {
    // TODO: maybe remove error thrown, there are cases when no version is available
    // e.g. the context is not set, no current patient etc.
  }

  const model = await currentCaseService.getModel();

  const keyForReRender = ref(0);

  getContext(context).addEventListener(
    ApplicationEvents.CaseOpenedForEditing,
    async () => {
      const currentCrfVersions = currentCaseService.getCrfVersions();
      if (!isEqual(currentCrfVersions, crfVersions)) {
        crfVersions = currentCrfVersions;
      }
      keyForReRender.value = keyForReRender.value + 1;
    }
  );
  return { keyForReRender, crfVersions, model };
}

// Funzione di zoom
function handleMouseMove(event: MouseEvent) {
  const svg = (event.currentTarget as HTMLElement).querySelector('svg');
  if (!svg) return;

  const { clientX, clientY } = event;
  const svgRect = svg.getBoundingClientRect();
  const svgX = clientX - svgRect.left;
  const svgY = clientY - svgRect.top;

  // Calcolare la trasformazione per il layer di zoom
  zoomStyle.value = {
    transform: `translate(${-svgX * (zoomLevel.value - 1)}px, ${-svgY * (zoomLevel.value - 1)}px) scale(${zoomLevel.value})`,
    transformOrigin: `${svgX}px ${svgY}px`,
  };
}

function resetZoom() {
  zoomed.value = false;
  zoomStyle.value = {};
}
</script>

<style scoped>
path {
  opacity: 0.15;
}

path:hover {
  cursor: pointer;
  opacity: 0.3;
}

.selected {
  cursor: pointer;
  opacity: 0.8 !important;
}
</style>
